<ng-container #formDirective="parent-form" thr-parent-form>
    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                <span class="num"></span> {{ 'full-data.source-of-funds' | translate }}:
            </h3>
            <mat-radio-group name="fdenpSourceOfFundsKYC" [(ngModel)]="client.professional.sourceOfFundsKYC" required [disabled]="isDisabled">
                <div class="row">
                    <div class="col-12 col-sm-6 col-md-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdenpHeritage" color="blue-gray" [value]="SourceFunds.HERITAGE">
                            {{ 'full-data.inversis.source-funds.heritage' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdenpSavings" color="blue-gray" [value]="SourceFunds.INHERITANCE_OR_SAVINGS">
                            {{ 'full-data.inversis.source-funds.inheritance-or-savings' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdenpSalaries" color="blue-gray" [value]="SourceFunds.SALARIES">
                            {{ 'full-data.inversis.source-funds.salaries' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdenpOther" color="blue-gray" [value]="SourceFunds.OTHER">
                            {{ 'full-data.inversis.source-funds.other' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdenpSales" color="blue-gray" [value]="SourceFunds.REAL_ESTATE_SALES">
                            {{ 'full-data.inversis.source-funds.real-estate-sales' | translate }}
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                {{ 'form.documents' | translate }}
            </h3>
            <p>{{ 'full-data.inversis.additional-documentation' | translate }}</p>
            <ng-template ngFor let-document [ngForOf]="client.documentsOriginFunds" let-i="index">
                <div class="my-3 mb-sm-4">
                    <thr-file-selector [name]="'fdpDocument' + i" [label]="document.name" [filename]="document.filename" [canView]="document.id && !document.file" filesize [maxSize]="maxSize" filetype [allowedTypes]="allowedTypes" [allowedExtension]="allowedExtension" [required]="!document.optional && (!document.id || document.remove)"
                        [disabled]="isDisabled" [(ngModel)]="document.file" (view)="onDocumentView(document)" (remove)="onDocumentRemove(document)" #documentCtrl="ngModel"></thr-file-selector>
                    <mat-hint class="d-block mat-caption font-italic mt-2 text-blue" *ngIf="documentCtrl.valid">
                        {{ 'form.documents-help-zip' | translate: { size: 25 } }}
                    </mat-hint>
                    <mat-error class="d-block mat-caption font-italic mt-2" *ngIf="documentCtrl.hasError('filetype') && !documentCtrl.hasError('required')">
                        {{ 'form.validation.filetype' | translate }}
                    </mat-error>
                    <mat-error class="d-block mat-caption font-italic mt-2" *ngIf="documentCtrl.hasError('filesize') && !documentCtrl.hasError('required')">
                        {{ 'form.validation.filesize' | translate: { size: 25 } }}
                    </mat-error>
                    <mat-error class="d-block mat-caption font-italic mt-2" *ngIf="documentCtrl.hasError('required')">
                        {{ 'form.validation.required' | translate }}
                    </mat-error>
                </div>
            </ng-template>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                <span class="num"></span> {{ 'full-data.inversis.purpose-account' | translate }}:
            </h3>
            <div class="d-none">
                <input name="fdenpPurposeKYC" [(ngModel)]="client.professional.purposeKYC" required />
            </div>
            <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-3">
                    <mat-radio-button class="mb-3 mb-sm-4" name="fdenpISave" color="blue-gray" [disabled]="isDisabled" [checked]="save" (click)="onChangePurpose( 'save')">
                        {{ 'full-data.inversis.i-save' | translate }}
                    </mat-radio-button>
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                    <mat-radio-button class="mb-3 mb-sm-4" name="fdenpInvestment" color="blue-gray" [disabled]="isDisabled" [checked]="investment" (click)="onChangePurpose( 'investment')">
                        {{ 'full-data.inversis.investment' | translate }}
                    </mat-radio-button>
                </div>
                <div class="col-12 col-md-6">
                    <mat-radio-button class="mb-3 mb-sm-4" name="fdenpTransactions" color="blue-gray" [disabled]="isDisabled" [checked]="transactions" (click)="onChangePurpose( 'transactions')">
                        {{ 'full-data.inversis.transactions' | translate }}
                    </mat-radio-button>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                <span class="num"></span> {{ 'full-data.inversis.transfers-per-month' | translate }}
            </h3>
            <mat-radio-group name="fdenpTransfersKYC" [(ngModel)]="client.professional.numberOfTransfersKYC" required [disabled]="isDisabled">
                <div class="row">
                    <div class="col-12 col-sm-6 col-md-3">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdenpTransfersLow" color="blue-gray" [value]="1">
                            {{ 'full-data.inversis.transfers-low' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-3">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdenpTransfersMedium" color="blue-gray" [value]="2">
                            {{ 'full-data.inversis.transfers-medium' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-3">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdenpTransfersHigh" color="blue-gray" [value]="3">
                            {{ 'full-data.inversis.transfers-high' | translate }}
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                <span class="num"></span> {{ 'full-data.inversis.operations-per-month' | translate }}
            </h3>
            <mat-radio-group name="fdenpOperationsKYC" [(ngModel)]="client.professional.numberOfTransactionsKYC" required [disabled]="isDisabled">
                <div class="row">
                    <div class="col-12 col-sm-6 col-md-3">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdenpOperationsLow" color="blue-gray" [value]="1">
                            {{ 'full-data.inversis.operations-low' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-3">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdenpOperationsMedium" color="blue-gray" [value]="2">
                            {{ 'full-data.inversis.operations-medium' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-3">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdenpOperationsHigh" color="blue-gray" [value]="3">
                            {{ 'full-data.inversis.operations-high' | translate }}
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                <span class="num"></span> {{ 'full-data.inversis.estimated-equity-keep' | translate }}
            </h3>
            <mat-radio-group name="fdenpEstimatedKYC" [(ngModel)]="client.professional.estimatedPositionKYC" required [disabled]="isDisabled">
                <div class="row">
                    <div class="col-12 col-sm-6 col-md-3">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdenpEstimatedLow" color="blue-gray" [value]="1">
                            {{ 'full-data.inversis.estimated-low' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-3">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdenpEstimatedMedium" color="blue-gray" [value]="2">
                            {{ 'full-data.inversis.estimated-medium' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-3">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdenpEstimatedHigh" color="blue-gray" [value]="3">
                            {{ 'full-data.inversis.estimated-high' | translate }}
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
        </div>
    </div>

    <div class="row justify-content-end" *ngIf="!isDisabled && !isDisabledSubmit">
        <div class="col-12 col-sm-6 col-md-4">
            <button type="submit" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="!isFormValid">
                {{ 'general.save' | translate }}
            </button>
        </div>
    </div>
</ng-container>
